import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionCalendarService = {
  async getProductionProcess() {
    const requestScreenData = {
      url: "api/Process",
      filter: `IsCriticalProcess eq 'Y' and Inactive eq 'N'`,
      select: "Code, Description ,Inactive, IsCriticalProcess",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getScheduleNote(recordId) {
    const requestScreenData = {
      url: "api/ProductionScheduleNote",
      filter: `RecordId eq ${recordId}`,
      expand: "ProductionScheduleNoteProcesses",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkHours(startDate, endDate, ProcessCode) {
    const requestScreenData = {
      url: "api/ProcessCalendarPreview",
      filter: `ShiftDateStart ge ${startDate} and ShiftDateStart le ${endDate}`,
      // select: 'Date, StartTime, EndTime'
      orderby: "ShiftDateStart asc",
    };

    if (ProcessCode) {
      requestScreenData.filter += ` and ProcessCode eq '${ProcessCode}'`;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveScheduleNote(scheduleNote) {
    const url = "api/ProductionScheduleNote/Notes";

    return await ApiService.post(url, scheduleNote);
  },
};

export { ProductionCalendarService };
